import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { search_tab } from "./search_tab";
import { ResultList } from "./ResultList";
import masterData from "../../lib/masterData";
import { getUrl, searchAsset, findStation } from "../../lib/masterUtil";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import Accordion from "semantic-ui-react/dist/commonjs/modules/Accordion";
import { TYPE_PC, TYPE_SP } from "../../common/defines";

export class Area extends React.Component {
  state = {};
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props);
    this.context = context;
    this.state = this.getState(props, context);
//    console.log("Area constructor", this.state.value);
  }
  /* eslint-disable complexity */
  getState(props, context) {
    const paramsString = props.location.search;
    const searchParams = new URLSearchParams(paramsString);
    let value = { condition: {} };
    for (const [paramKey, paramValue] of searchParams) {
      if (paramValue[0] === '(') {
        if (paramValue.length > 2) {
          value.condition[paramKey] = paramValue.slice(1, -1).split('.');
        }
      } else {
        value.condition[paramKey] = paramValue;
      }
    }
    console.log('condition = ', value.condition )
    const params = props.match.params;
    const line = params && params.line ? masterData.line.bySlug[params.line] : null;
    const stationId = params && findStation(line, params.station)
    console.log('getState', line, stationId)
    if (line) {
      value.condition = value.condition || {};
      value.condition.line = [line.slug];
    }
    if (stationId) {
      value.condition = value.condition || {};
      value.condition.station = [stationId];
    }
    const pref = params.pref ? masterData.pref.bySlug[params.pref] : null;
    let city_slug = params.city;
    if (params.district) {
      city_slug = params.city + params.district;
    }
    const city = pref && city_slug ? masterData.city.byPrefAndSlug[pref.prefId][city_slug] : null;
    const district = city && city.districtSlug ? city.districtSlug : null;
    if (pref) {
      value.condition = value.condition || {};
      value.condition.pref = value.condition.pref || pref.prefId;
    }
    if (city) {
      value.condition = value.condition || {};
      value.condition.city = value.condition.city || [city.slug];
    }
    // 検索条件の展開状態を設定
    let activeIndex = !value.condition || Object.keys(value.condition).length == 0 ? 1 : null;
    // トップページからの遷移なら最初は展開しておく
    if (value.condition.fromTop) {
      delete value.condition.fromTop;
      activeIndex = 1;
    }
    const list = searchAsset(value, {});
//    console.log("new value", value, list);
    // 検索条件が指定されていない時は条件入力エリアを表示する
    return {
      value,
      list,
      activeIndex: activeIndex,
    };
  }
  componentWillReceiveProps(nextProps) {
//    console.log(
//      "Area componentWillReceiveProps",
//      nextProps,
//      this.context.router.history.location
//    );
    const newState = this.getState(nextProps, this.context);
    this.setState(newState);
  }
  resetScroll = mode => {
    let target = this;
    if (mode === "list") {
      target = this.refs.searchResult;
    }
    ReactDOM.findDOMNode(target).scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  getScrollTarget() {
    // Areaは、検索後必ず地図ページに飛ぶので、トップにスクロールする
    return this;
  }
  onClickSearchButton(value) {
    const url = getUrl(value);
    this.context.router.history.push(url);
    ReactDOM.findDOMNode(this.getScrollTarget()).scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
  toggleDescription = () => {
    this.setState({
      activeIndex: this.state.activeIndex ? null : 1,
    });
  };
  render() {
    const type = this.props.type;
    const params = this.props.match.params;
    const condition = (this.state.value && this.state.value.condition) || {};
    const pref = condition.pref ? (masterData.prefAsync || masterData.pref).byId[condition.pref] : null;
    const city = pref && params.city ? masterData.city.byPrefAndSlug[pref.prefId][params.city] : null;
    if(pref && !city){
      //document.title = `${pref.name}でトランクルームをお探しなら『ハローストレージ${pref.name}』`;
    }else if(pref && city){
      //document.title = `${pref.name}・${city.name}でトランクルームをお探しなら『ハローストレージ${pref.name}』`;
    }

    return (
      <div className="container">
        {(() => {
          if (pref && !city) {
            return breadcrumbs(type, [
              { href: `/${pref && pref.slug}/`, text: pref.name },
            ]);
          } else if (pref && city && !city.districtSlug) {
            return breadcrumbs(type, [
              { href: `/${pref && pref.slug}/`, text: pref.name },
              { href: `/${pref && pref.slug}/${city.slug}/`, text: city.name}
            ]);
          } else if (pref && city && city.baseSlug) {
            const baseCity = masterData.city.byPrefAndSlug[pref.prefId][city.baseSlug];
            return breadcrumbs(type, [
              { href: `/${pref && pref.slug}/`, text: pref.name },
              { href: `/${pref && pref.slug}/${base_city_data.slug}/`, text: baseCity.name },
              { href: `/${pref && pref.slug}/${city.districtSlug}/`, text: city.districtName }
            ]);
          }
        })()}
        
        <div className="content">
          <div className="control">
            <div className="title">
              {(() => {
                if (pref && !city) {
                  return (
                    <h1>
                      <span>
                        <span className="area_name">{pref.name}</span>
                        のトランクルームを探す
                      </span>
                    </h1>
                  );
                }else if(pref && city){
                  return (
                    <h1>
                      <span>
                        <span className="area_name">{pref.name}{city.name}</span>
                        のトランクルームを探す
                      </span>
                    </h1>
                  );
                }
              })()}
            </div>
            {search_tab(this.props, pref, this.state.value, value => {
              this.onClickSearchButton(value);
            })}
          </div>
          <div ref="searchResult" />
          <ResultList
            {...{
              type,
              list: this.state.list,
              resetScroll: this.resetScroll,
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/Area.jsx